import React, { Component } from 'react'
import { observer } from 'mobx-react'
import cls from 'classnames'
import Upload from '@common/Upload'
import { Select, MagicInput, Checkbox, InputNumber, Alert } from 'hljd'
import styles from '../../style.module.less'
import { getChartLength } from '@util'
import { isSiDaProperty } from '@merchant-backend/util'

const CheckboxGroup = Checkbox.Group
let imgFilters = {
  mime_types: [{ title: 'Image files', extensions: 'jpg,png,jpeg,bmp' }]
}

const Option = Select.Option

@observer
/**
 * @description: 2021/0520 司仪改版，将司仪页面单独抽离，外部调用判断，这个页面修改的内容有点多，写在外面的话会不必要判断有点多，因此考虑新开页，同时重构掉这块的逻辑--有时间的话
 * @param {*}
 * @return {*}
 */
export default class extends Component {
  //获取地址
  getLocation = (options, values) => {
    let provice = options.find(item => item.value == values[0]) || {}
    let city = provice.children || []
    let area = city.find(item => item.value == values[1]) || {}
    return area.children || []
  }

  getYears = () => {
    const endYear = new Date().getFullYear()
    const results = []
    let startYear = 1950
    while (startYear <= endYear) {
      results.push(startYear)
      startYear++
    }
    return results.sort((a, b) => b - a)
  }

  render() {
    const { store } = this.props
    const {
      avatar,
      name,
      workingAt,
      des,
      servicePrice,
      servicePriceTip,
      property_id,
      realName,
      certify,
      certifyFront,
      certifyBack,
      auditFailedReason,
      bandWord
    } = store
    let style = { marginLeft: 190 }
    const years = this.getYears()
    const defaultYear = new Date().getFullYear() - 5
    return (
      <>
        {auditFailedReason && (
          <Alert
            message={'审核不通过原因：' + auditFailedReason}
            type="error"
            showIcon
            style={{ marginTop: 10 }}
          />
        )}
        <div
          className={cls({
            [styles.edit]: true,
            [styles.register_edit]: true
          })}
        >
          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must} style={{ verticalAlign: 165 }}>
              头像
            </span>
            <Upload
              clipabled
              link={avatar ? avatar : ''}
              onOk={store.upload('avatar')}
              onDelete={store.removeImg('avatar')}
              target="_self"
              aspect={400 / 400}
              onCliped={store.clipPic('avatar')}
              filters={imgFilters}
              style={{ height: 200, width: 200 }}
            />
            <div className={styles.logoExample}>
              <p>示例：</p>
              <img src="https://qnm.hunliji.com/o_1dicjvgqm1djv1q1l1qjjl261kcc9.png" />
            </div>
            <p className={styles.txt}>
              头像中不能包含营销信息、联系方式、微信、微博、网址二维码等
            </p>
            <p
              className={styles.txt}
              style={{ color: '#448AFCFF', marginTop: 2 }}
            >
              建议尺寸400*400像素
            </p>
          </div>

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must}>称呼</span>
            <MagicInput
              size="large"
              placeholder="请输入您的称呼"
              style={{ width: 460 }}
              onChange={e => store.changeField('name')(e.target.value)}
              value={name}
              maxLength={4}
              showCount
              countPosition="right"
              lengthCount={value => getChartLength(value, 'floor')}
            />
            <p className={styles.txt}>
              不支持符号、表情和描述性文字，不超过4个字
            </p>
            <p className={styles.txt} style={{ marginTop: 2 }}>
              无需输入职业，团队名称将在您加入团队后自动添加
            </p>
          </div>

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must}>入行时间</span>
            <Select
              size="large"
              style={{ width: 460 }}
              value={workingAt || undefined}
              onChange={store.changeField('workingAt')}
              placeholder="请选择入行时间"
              onDropdownVisibleChange={() => {
                if (!workingAt) {
                  store.changeField('workingAt')(defaultYear)
                }
              }}
            >
              {years.map(item => (
                <Option value={item} key={item}>
                  {item} 年
                </Option>
              ))}
            </Select>
          </div>

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must}>成员价格</span>
            <InputNumber
              size="large"
              placeholder="请输入司仪的价格"
              precision={0}
              max={999999}
              min={0}
              value={servicePrice}
              onChange={store.changeField('servicePrice')}
              style={{ width: 460 }}
            />
            <span className={styles.after}>元</span>
          </div>
          <div className={styles.item} style={{ ...style }}>
            <span className={styles.normal}>价格包含</span>
            <CheckboxGroup
              value={servicePriceTip}
              onChange={store.changeField('servicePriceTip')}
            >
              <Checkbox value={1}>音乐督导</Checkbox>
              <Checkbox value={2}>现场督导</Checkbox>
            </CheckboxGroup>
          </div>

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.atwill}>个人简介(可选)</span>
            <MagicInput.TextArea
              autoSize={{ minRows: 6, maxRows: 10 }}
              style={{ width: 460 }}
              placeholder="请填写个人简介"
              onChange={e => store.changeField('des')(e.target.value)}
              onBlur={e => store.checkBanedWord(e.target.value)}
              value={des}
              maxLength={isSiDaProperty(property_id) ? 100 : 19}
              showCount
              countPosition="inner"
            />
            <>
              {bandWord && <p className={styles.textError}>{bandWord}</p>}
              <p className={styles.txt}>
                请从从业经历、技术特点等方面介绍自己，不超过100字
              </p>
              <p className={styles.txt} style={{ marginTop: 2 }}>
                请勿包含网址、微信、手机号、支付方式等，以及“最”、“独一无
              </p>
              <p className={styles.txt} style={{ marginTop: 2 }}>
                二”等违反广告法的极限词。
              </p>
            </>
          </div>
          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must}>真实姓名</span>
            <MagicInput
              size="large"
              value={realName}
              placeholder="请输入真实姓名"
              style={{ width: 460, height: 44 }}
              onChange={e => store.changeField('realName')(e.target.value)}
            />
          </div>

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must}>身份证号</span>
            <MagicInput
              size="large"
              value={certify}
              placeholder="请输入法人证件号码"
              style={{ width: 460, height: 44 }}
              onChange={e => store.changeField('certify')(e.target.value)}
            />
          </div>

          <div className={styles.item} style={{ ...style, display: 'flex' }}>
            <span className={styles.must} style={{ verticalAlign: 165 }}>
              身份证正面
            </span>

            <Upload
              showDelete
              link={certifyFront ? certifyFront : ''}
              onOk={store.upload('certifyFront')}
              onDelete={store.removeImg('certifyFront')}
              uptoken_url={'image_upload_token?from=timestamp_antileech'}
              style={{ width: 200, height: 200 }}
            />
            <div className={styles.example}>
              <p className={styles.p1}>示例：</p>
              <div className={styles.image}>
                <img src="//qnm.hunliji.com/o_1b40mdafe154jstg1s9e1nemgojr.png?imageView2/2/h/116" />
              </div>
              <p className={styles.p2}>要求证件上的文字清晰可识别</p>
            </div>
          </div>

          <div className={styles.item} style={{ ...style, display: 'flex' }}>
            <span className={styles.must} style={{ verticalAlign: 165 }}>
              身份证反面
            </span>
            <Upload
              showDelete
              link={certifyBack ? certifyBack : ''}
              onOk={store.upload('certifyBack')}
              onDelete={store.removeImg('certifyBack')}
              uptoken_url={'image_upload_token?from=timestamp_antileech'}
              style={{ width: 200, height: 200 }}
            />
            <div className={styles.example}>
              <p className={styles.p1}>示例：</p>
              <div className={styles.image}>
                <img src="//qnm.hunliji.com/o_1b40mdcns1afr1n4p6ro19r8jk510.png?imageView2/2/h/116" />
              </div>
              <p className={styles.p2}>
                要求证件上的文字清晰可识别 <br />
                有效期在一个月以上
              </p>
            </div>
          </div>
        </div>
      </>
    )
  }
}
